import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/serverProvider/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/serverProvider/exportExcel', data, {
    trim: true,
    download: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/serverProvider/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/serverProvider/updateById', data)
}

// 修改状态
export function updateStatus (data) {
  return request.post('/business/serverProvider/updateStatus', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/serverProvider/delete/${id}`)
}

// 根据ID查询
export function getById (id) {
  return request.get(`/business/serverProvider/${id}`)
}
